var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconDuplicate = function SvgIconDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.833 12A1.84 1.84 0 0 1 0 10.154V1.846C0 .826.82 0 1.833 0h7.334A1.84 1.84 0 0 1 11 1.846",
    id: "icon-duplicate_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 3)",
    stroke: "#000",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-duplicate_svg__a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85,
    y: 3.85,
    width: 10.8,
    height: 11.8,
    rx: 2
  })))));
};

export default SvgIconDuplicate;